@if (showPam()) {
  <bit-nav-group icon="bwi-shield" [text]="'pam' | i18n" route="pam">
    <bit-nav-item [text]="'pamAccessRules' | i18n" route="pam/access-rules"></bit-nav-item>
  </bit-nav-group>
}
